import { render, staticRenderFns } from "./StepInformacoes.vue?vue&type=template&id=75f979bf&scoped=true"
import script from "./StepInformacoes.vue?vue&type=script&lang=js"
export * from "./StepInformacoes.vue?vue&type=script&lang=js"
import style0 from "./StepInformacoes.vue?vue&type=style&index=0&id=75f979bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f979bf",
  null
  
)

export default component.exports